import {
  ChangeEvent,
  CSSProperties,
  forwardRef,
  ForwardRefExoticComponent,
  RefAttributes,
} from 'react'
import { cn } from 'shared/styles'

type Props = ForwardRefExoticComponent<
  {
    width?: string
    label?: string
    required?: boolean
    isValid: boolean
    disabled?: boolean
    value?: string
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
    onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    placeholder?: string
    maxLength?: number
    style?: CSSProperties
  } & RefAttributes<HTMLInputElement>
>

export const InputWithRef: Props = forwardRef(
  ({ width, label, required, isValid, disabled, ...props }, ref) => (
    <div className={cn('flex items-center gap-x-2.5', !width && 'grow')}>
      {label && (
        <label className='text-base font-medium text-gray-900'>
          {label}
          {required && <span className='text-red-600'>*</span>}
        </label>
      )}
      <input
        className={cn(
          'hide-arrows rounded-md px-3 py-2 placeholder:text-ellipsis',
          disabled
            ? 'cursor-not-allowed placeholder-gray-200'
            : isValid
              ? 'border-gray-300 hover:border-blue-600'
              : 'border-red-600',
          width || 'w-full',
        )}
        type='text'
        ref={ref}
        disabled={disabled}
        {...props}
      />
    </div>
  ),
)
